import { Injectable } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import { EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import { iBisAuthService, iBisSecureEditService } from '@dohu/ibis-auth';
import { iBisLanguageService, iBisServerConfig } from '@dohu/ibis-common';
import { DataService } from '../../../service/data.service';
import { AuthDetailsService } from '../../../common/auth-details/auth-details.service';
@Injectable({
    providedIn: 'root'
})
export class EditServicePackageService extends iBisSecureEditService {
    public data: CustomStore;

    private pId: string;
    constructor(auth: iBisAuthService, entity: iBisEntityService, config: iBisServerConfig, lg: iBisLanguageService, private ad: AuthDetailsService) {
        super(auth, entity, config, lg);
        this.title = 'SERVICE';
        this.validation = 'ProcedureValidation';
    }

    protected load(): void {
        this.data = this.getData();
    }

    public set packageId(id: string) {
        this.pId = id;
    }

    public get packageId() {
        return this.pId;
    }

    createDefault(): any {
        return { };
    }
    getById(id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve({});
           /*  this.entity.getById('Procedure', id).then((obj) => {
                if (obj) {
                    resolve(obj);
                } else {
                    reject();
                }
            }, error => this.lg.showError(error)); */
        });
    }
    onRemove(id: string): Promise<void> {
        return this.entity.remove('Procedure', id);
    }
    onSaveEv(serverUrl?: string): Promise<any> {
        return this.entity.save('Procedure', this.model.id, this.model);
    }
    reset(): void {
        this.model = this.createDefault();
    }




    private getData(): CustomStore {
        const q = new EntityQuery('Procedure').addOrderBy(['code']);
       /*  if (this.pId) {
            q.eq('specializationId', this.pId);
        } */
        return this.entity.store(q);
    }
}
